module.exports = __webpack_public_path__ + "img/store-front.4c54118e.svg";